var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 21 3",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        attrs: { cx: "1.5", cy: "1.5", r: "1.5", fill: _vm.color }
      }),
      _c("circle", {
        attrs: {
          cx: "7.5",
          cy: "1.5",
          r: "1.5",
          fill: _vm.color,
          "fill-opacity": "0.8"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "13.5",
          cy: "1.5",
          r: "1.5",
          fill: _vm.color,
          "fill-opacity": "0.7"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "19.5",
          cy: "1.5",
          r: "1.5",
          fill: _vm.color,
          "fill-opacity": "0.5"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }